import React,{ Component} from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';

import styles from './styles.module.css';
import SectionTitle from '../../shared/components/SectionTitle';
import { isLoadingProductTypesList, getProductTypesList, getProductTypeDetails, getProductTypeDetailsWithProducts } from '../../shared/state/productTypes/selectors';
import { loadProductTypes } from '../../shared/state/productTypes/actions';
import ProductTypeCard from '../../shared/components/ProductTypeCard';
import { areProductsListLoaded, getProductDetails } from '../../shared/state/products/selectors';
import { getEditorialData } from '../../shared/state/editorial/selectors';
import ProductsPreviewPopup from '../../shared/components/ProductsPreviewPopup';

class ProductsByTypePage extends Component{
    state = {
        productPreviewOpen: false,
        productIndexSelected: undefined
    }

    handleProductClick = (i) => this.setState({
        productPreviewOpen: true,
        productIndexSelected: i
    });

    handleProductPreviewClose = () => this.setState({
        productPreviewOpen: false,
        productIndexSelected: undefined
    });

    render = () => {
        const {
            productType: {name, products=[]}  = {}, areProductsLoaded, areProductTypesLoaded,
            editorialData: {productsHeaderImage: {url: photoUrl} = {}}
        } = this.props;

        const {productPreviewOpen, productIndexSelected}  = this.state;

        return (
            <div className={styles.main}>
                {
                    productPreviewOpen ? (
                        <ProductsPreviewPopup 
                            indexSelected={productIndexSelected}
                            products={products}
                            onClose={this.handleProductPreviewClose}/>
                    ) : null
                }
                <div>

                </div>
                <div className={styles.productsHeader}>
                    <img src={photoUrl}/>
                </div>

                <div className={styles.productsWrapper}>
                    <Link to='/produtos'>
                        <div className={styles.backButton}>
                            { '< Voltar Atrás' }
                        </div>
                    </Link>
                    <SectionTitle 
                        center={false}
                        title={name}/>

                        <div className={styles.productsList}>
                            {
                                products.map(({name, photo: {url: photoUrl}} , i)  => 
                                    <div
                                        className={styles.product} 
                                        key={i}
                                        onClick={()=>this.handleProductClick(i)}>
                                        <div 
                                            className={styles.productImage}
                                            style={{backgroundImage: `url('${photoUrl}')`}}>
                                        </div>
                                    </div>
                                )      
                            }
                        </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = () => {
    return (state, {match: {params: {typeId}={}}}) => ({
        areProductTypesLoaded: areProductsListLoaded(state),
        areProductsLoaded: areProductsListLoaded(state),
        productType: getProductTypeDetailsWithProducts(state, {productTypeId: typeId}),
        editorialData: getEditorialData(state),
    });
};

export default connect(mapStateToProps)(ProductsByTypePage);